import {CanMatchFn} from '@angular/router';

const allowedFixtureStates = new Set(['product-cards']);
const allowedFixturePaths = new Set([
  '/ai/conversations',
  '/ai/conversations/fixture-thread',
]);

export function isConversationVisualFixtureUrl(href: string): boolean {
  const url = new URL(href);
  const isLocalHost = ['localhost', '127.0.0.1', '[::1]', '::1'].includes(url.hostname);
  const fixtureState = url.searchParams.get('conversationVisualFixture') || '';

  return isLocalHost && allowedFixturePaths.has(url.pathname) && allowedFixtureStates.has(fixtureState);
}

export const conversationVisualFixtureCanMatch: CanMatchFn = () => {
  if (typeof window === 'undefined' || !window.location) return false;

  return isConversationVisualFixtureUrl(window.location.href);
};
